"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNakedVariantClass = exports.getInputContainerClass = void 0;

var _constants = require("./constants");

var getInputContainerClass = function getInputContainerClass(readOnly) {
  if (readOnly) {
    return _constants.inlineEditClasses.inputContainerReadOnly;
  }

  return _constants.rawTextClasses.inputContainer;
};

exports.getInputContainerClass = getInputContainerClass;

var getNakedVariantClass = function getNakedVariantClass(value, placeholder, error) {
  if (error) {
    return _constants.inlineEditClasses.variantNakedError;
  }

  if (!value && !placeholder) {
    return _constants.inlineEditClasses.variantNakedEmpty;
  }

  return _constants.rawTextClasses.variantNaked;
};

exports.getNakedVariantClass = getNakedVariantClass;